import TermsAndConditions from 'baby-ui/compounds/TermsAndConditions'

interface ReplacementPartsAOBProps {
  open: boolean
  onAgree: () => void
  onDisagree: () => void
}

const ReplacementPartsAOB = ({
  open,
  onAgree,
  onDisagree,
}: ReplacementPartsAOBProps) => (
  <TermsAndConditions
    clauses={[
      {
        title: (
          <p>
            By digitally signing this document you acknowledge that you are
            still using your breast pump and are in need of replacement parts to
            keep your breast pump functioning to the best of its capabilities.
          </p>
        ),
        type: 'unordered',
        terms: [],
      },
      {
        title: (
          <p>
            You also authorize Babylist Health LLC and Medequip Inc., a member
            of Babylist's Preferred Durable Medical Equipment Network, to submit
            claims to your insurance company on your behalf and request on your
            behalf all insurance information, prescriptions and benefits for
            products provided as well as to release your medical records to any
            person, organization, company and/or agency which may be involved in
            providing your care.
          </p>
        ),
        type: 'unordered',
        terms: [],
      },
      {
        title: (
          <p>
            You also acknowledge that you have not ordered breast pump
            replacement parts through another DME provider.
          </p>
        ),
        type: 'unordered',
        terms: [],
      },
    ]}
    open={open}
    title="Replacement Parts Use Acknowledgement"
    onAgree={onAgree}
    onDisagree={onDisagree}
  />
)

export default ReplacementPartsAOB
